module.exports = __webpack_public_path__ + "img/roadmap.42e2aefe.svg";